export enum VasCodesType {
  SHOWMAXAddon = 'SHOWMAXADDON',
  SHOWMAXAddonPL = 'SHOWMAXADDONPL',
  SHOWMAXOTT = 'SHOWMAXOTT',
  SHOWMAXE36 = 'SHOWMAXE36',
  SHOWMAXIS20 = 'SHOWMAXIS20',
  BRITBOX = 'BritBox Add-On',
  NETFLIX = 'Netflix',
  DISNEY = 'Disney',
  MOVIES = 'MOVIESOTT',
  STREAMMOBILE = 'STREAM MOBILE',
  FLEX = 'Flex'
}

export const ThirdPartyVasCodes = [
  VasCodesType.BRITBOX,
  VasCodesType.NETFLIX,
  VasCodesType.DISNEY
]
